import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      paddingBottom: 50,
    },
    shield: {
      marginTop: 32,
    },
    header4: {
      ...theme.fonts.h4,
      marginTop: 32,
    },
    usernameSection: {
      marginTop: 17,
      "& > span": {
        ...theme.fonts.p2,
        color: theme.colors.textSubtle,
        marginLeft: 4,
      },
    },
    desc: {
      textAlign: "left",
      marginTop: 32,
    },
    registrationCompletedSection: {
      marginTop: 44,
      display: "flex",
      width: 366,
      "& > span": {
        marginLeft: 8,
        marginTop: 2,
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        textAlign: "start",
      },
    },
    gotoLoginButtonStyle: {
      marginTop: 24,
      width: "100%",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
